import React from 'react'
import {makeStyles, Tooltip, Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import ExpansionPanel from 'components/ExpansionPanel';
import {setConfirmCloseStepper, setStepperState} from 'redux/actions'
import {connect} from 'react-redux'
import NavigationBar from 'components/complex/floatingMenu/NavigationBar';
import ArrowIcon from '@material-ui/icons/KeyboardArrowUp'
import clsx from 'clsx';
import GridBlock from 'components/GridBlock';
import Tr from 'translations/Translations';
import Loading from 'components/Loading';
import ExpansionPanelTitleAvatar from "components/ExpansionPanelTitleAvatar";
import {DemandValidationSectionStatus as sectionStatus} from "constants/DemandValidationSectionStatus";


const useStyle = makeStyles(theme => ({
    root: {
        height: '100%',
        '&>*:not(:first-child)': {
            marginTop: theme.spacing(2)
        }
    },
    floatingMenu: {
        position: 'sticky',
        zIndex: theme.zIndex.appBar - 1,
        top: 109
    },
    rotate: {
        transform: 'rotate(180deg)'
    },
    adornmentGrid: {
        '&>*:first-child': {
            flexGrow: 1,
            marginRight: theme.spacing(2)
        }
    }
}))

function AccordionPart(
    {
        navigationBarButtons,
        working,
        steps,
        panels,
        stepperState,
        setStepperState,
        demandValidation,
        redirectOldPlatform,
        stateCloseValidator,
        deleteFormDraftFunc,
        saveFormDraftFunc,
        setConfirmCloseStepper
    }) {
    const classes = useStyle();

    const handleClick = id => (e) => {
        if (stateCloseValidator && stateCloseValidator() === false) {
            if (!!saveFormDraftFunc) {
                setConfirmCloseStepper(() => doHandleClick(id), Tr(stepperState), () => doHandleClickWithDraftSave(id));
            } else {
                setConfirmCloseStepper(() => doHandleClick(id), Tr(stepperState));
            }
            return
        }
        doHandleClick(id)
    }

    const doHandleClick = id => {
        if (!!deleteFormDraftFunc)
            deleteFormDraftFunc();
        _doHandleClick(id);
    }

    const doHandleClickWithDraftSave = id => {
        if (!!saveFormDraftFunc) {
            saveFormDraftFunc();
        }
        _doHandleClick(id);
    }

    const _doHandleClick = id => {
        if (stepperState !== id) setStepperState(id);
        else setStepperState(null);
    }

    const createTitle = (variant, label) => {
        return (
            <GridBlock alignItems="center">
                <ExpansionPanelTitleAvatar variant={variant}/>
                <Typography variant='h6'>
                    {label}
                </Typography>
            </GridBlock>
        )
    }

    if (!steps || !demandValidation || working || redirectOldPlatform) return <Loading/>
    return (
        <div className={classes.root}>
            {(!!navigationBarButtons && navigationBarButtons.length > 0) &&
                <div className={classes.floatingMenu}>
                    <NavigationBar buttons={navigationBarButtons}/>
                </div>
            }

            {steps.filter(({apiId}) => {
                const section = demandValidation.find(x => x.section === apiId)
                if (!section) return true;
                return section.status !== sectionStatus.UNAVAILABLE;
            })
                .map(({key, label, apiId}) => {
                    const section = demandValidation.find(x => x.section === apiId)
                    const variant = section ? (section.status === sectionStatus.OK ? 'Done' : (section.status === sectionStatus.DISABLED ? 'Wait' : (section.status === sectionStatus.ERROR ? 'Required' : (section.required ? 'Required' : 'Optional')))) : "Wait";
                    const _label = label;
                    const Component = panels[key]
                    return (
                        <ExpansionPanel
                            disabled={variant === 'Wait'}
                            key={key}
                            title={createTitle(variant, _label)}
                            titleAdornment={
                                <GridBlock
                                    wrap='nowrap'
                                    className={classes.adornmentGrid}
                                    alignItems='center'
                                >
                                    <div/>
                                    <Tooltip title={stepperState === key ? Tr('collapse') : Tr('expand')} placement='top'>
                                        <ArrowIcon
                                            className={clsx({
                                                [classes.rotate]: stepperState !== key
                                            })}
                                        />
                                    </Tooltip>
                                </GridBlock>
                            }
                            expanded={stepperState === key}
                            onChange={handleClick(key)}
                        >
                            <Component expanded={stepperState === key}/>
                        </ExpansionPanel>
                    )
                })}


        </div>
    )
}

AccordionPart.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    stepperState: state.stepper.state,
    stateCloseValidator: state.stepper.stateCloseValidator,
    deleteFormDraftFunc: state.stepper.deleteFormDraftFunc,
    saveFormDraftFunc: state.stepper.saveFormDraftFunc,
    demandValidation: state.resources.demandValidation,
    redirectOldPlatform: state.resources.redirectOldPlatform,
}), {
    setStepperState,
    setConfirmCloseStepper
})(AccordionPart);